module.exports = __webpack_public_path__ + "static/img/head_logo.34dc62d1.png";